import React, { Component } from 'react'
import { withStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';

const styles = theme => ({

    root: {
        backgroundColor: theme.palette.secondary.main,
        paddingTop: theme.spacing.unit * 2.5,
        paddingBottom: theme.spacing.unit * 2.5,
    },
    white: {
        color: 'white',
    }

});

class Footer extends Component {




    render() {

        const { classes } = this.props;


        return (
        <div className={classes.root}>
        
            <Grid container>

                <Grid item xs={12}>

                    <Typography variant="body1" align="center" className={classes.white}>
                        © Jordan Riley
                    </Typography>
                </Grid>
            </Grid>

        </div>
        )
    }


    
}


export default withStyles(styles)(Footer);